const component = require('../component/component');

const iconCss = Object.assign({}, component, {
    subelements: {
        iconDisplay: null,
        popoverButton: null,
        validationMessage: null
    },
    popover: null,
    sizeClass: '',

    init: function () {
        component.init.call(this);

        if (this.hasSubelement('popoverButton')) {
            this.initPopover();
        }
    },

    initPopover: function () {
        // Initialize the popover via the theme's behaviour adapter (manual
        // construction, not Bootstrap auto-init via data-bs-toggle, so we
        // control lifecycle).
        // sanitize: false is safe here because buildIconsGrid() generates all HTML from internal
        // app data — no user input is ever injected. The default Bootstrap sanitizer strips
        // data-* and title attributes from <span> elements, which breaks icon selection.
        this.popover = this.hm.behaviors.popover.create(this.subelements.popoverButton, {
            html: true,
            sanitize: false,
            content: () => this.buildIconsGrid(),
            trigger: 'click',
            placement: 'bottom'
        });

        // After the popover is shown, attach click handlers to the icon items inside it.
        // Subscribe via the adapter's neutral 'shown' event name; the adapter
        // wires the framework-specific DOM event (shown.bs.popover) internally.
        this.popover.on('shown', () => {
            let popoverId = this.subelements.popoverButton.getAttribute('aria-describedby');
            let popoverEl = document.getElementById(popoverId);
            if (popoverEl) {
                popoverEl.querySelectorAll('[data-icon-key]').forEach((iconEl) => {
                    iconEl.addEventListener('click', () => {
                        //this.hm.log('icon click', iconEl);
                        this.selectIcon(iconEl.dataset.iconKey);
                    });
                });
            }
        });
    },

    buildIconsGrid: function () {
        // Build an icon grid from the icons map, with a leading "none" entry to clear the value
        // Use the theme's removeClose icon for the "none" option, falling back to an empty string
        let noneIconClass = this.hm.app.icons['removeClose'] ?? '';
        let html = '<div class="zit-display-flex zit-flex-wrap zit-gap-2 zit-p-3">';

        // "None" option clears the current selection
        html += '<span class="zit-cursor-pointer zit-p-2 zit-rounded zit-border" data-icon-key="" title="' + this.hm.app.utext('none') + '">';
        html += '<i class="' + noneIconClass + ' ' + this.hm.app.cssClass('iconSizeLarge') + '"></i>';
        html += '</span>';

        for (let key in this.hm.app.icons) {
            let cssClass = this.hm.app.icons[key];
            html += '<span class="zit-cursor-pointer zit-p-2 zit-rounded" data-icon-key="' + key + '" title="' + this.hm.app.utext(key) + '">';
            html += '<i class="' + cssClass + ' ' + this.hm.app.cssClass('iconSizeLarge') + '"></i>';
            html += '</span>';
        }

        html += '</div>';
        return html;
    },

    selectIcon: function (iconKey) {
        // Save the icon key in the hidden input and dispatch the change event
        this.setElementValue(iconKey);

        // Update the visual icon element's CSS class
        let iconCssClass = iconKey ? (this.hm.app.icons[iconKey] ?? '') : '';
        this.subelements.iconDisplay.className = iconCssClass ? iconCssClass + ' ' + this.sizeClass : this.sizeClass;

        // Close the popover
        this.popover.hide();
    }
});

module.exports = iconCss;
